import { Column } from "react-table";
import { LabelHeader } from "../../components/table/table-headers";
import { DeadLetterSummary, formatUtc } from "../model/dead-letter";

export const NO_TENANT_LABEL = "no tenant";

const orDash = (value: string | null) => value ?? "—";

// The list is always newest first on the backend, so no column is sortable.
export const deadLetterTableColumns: Column<DeadLetterSummary>[] = [
  { Header: LabelHeader("Actions"), id: "actions" },
  {
    Header: LabelHeader("Received at (UTC)"),
    accessor: (row) => formatUtc(row.receivedAt),
    id: "receivedAt",
  },
  {
    Header: LabelHeader("Original topic"),
    accessor: (row) => orDash(row.originalTopic),
    id: "originalTopic",
  },
  {
    Header: LabelHeader("Tenant"),
    accessor: (row) => row.tenantName ?? NO_TENANT_LABEL,
    id: "tenantName",
  },
  {
    Header: LabelHeader("Event ID"),
    accessor: (row) => orDash(row.eventId),
    id: "eventId",
  },
  {
    Header: LabelHeader("Object ID"),
    accessor: (row) => orDash(row.objectId),
    id: "objectId",
  },
  {
    Header: LabelHeader("Topic"),
    accessor: (row) => orDash(row.topic),
    id: "topic",
  },
];
